import axios from 'axios';
import { get } from 'lodash/fp';
import { getFormValues } from 'redux-form';
import { EMAIL_SUBSCRIPTION_FORM } from '../constants';
import { uiDuck } from '../duck';

const subscriptionApiUrl = `/api/v1/subscription/`;

export const submitEmailSubscription = () =>
  function* ({ getState }) {
    const email = get(
      ['email'],
      getFormValues([EMAIL_SUBSCRIPTION_FORM])(getState()),
    );

    if (!email) {
      return;
    }

    yield axios.request({
      url: subscriptionApiUrl,
      data: {
        email,
        referrer_id: 'footer_newsletter',
      },
      method: 'POST',
    });

    yield uiDuck.set({ submitSuccess: true });
  };
